import Vue from 'vue'

export default function create(Component, props) {
  props = props.message ? props : { message: props }

  // 创建安全的容器元素
  const container = document.createElement('div')
  container.style.position = 'fixed'
  container.style.top = '0'
  container.style.left = '0'
  container.style.width = '100%'
  container.style.height = '0'
  container.style.overflow = 'visible'
  container.style.pointerEvents = 'none'
  container.style.zIndex = '9999'

  // 创建 Vue 实例
  const vm = new Vue({
    render: h => h(Component, { props })
  }).$mount()

  // 安全地添加到 DOM
  try {
    container.appendChild(vm.$el)
    document.body.appendChild(container)
  } catch (error) {
    console.warn('Failed to append notice to DOM:', error)
    // 如果失败，直接添加到 body
    try {
      document.body.appendChild(vm.$el)
    } catch (fallbackError) {
      console.error('Failed to append notice to body:', fallbackError)
      return null
    }
  }

  const comp = vm.$children[0]
  if (comp) {
    comp.remove = () => {
      try {
        // 先隐藏组件
        if (comp.hide) {
          comp.hide()
        }

        // 延迟移除 DOM 元素，避免动画冲突
        setTimeout(() => {
          try {
            if (container.parentNode) {
              document.body.removeChild(container)
            } else if (vm.$el.parentNode) {
              document.body.removeChild(vm.$el)
            }
          } catch (error) {
            console.warn('Failed to remove notice from DOM:', error)
          } finally {
            // 确保 Vue 实例被销毁
            vm.$destroy()
          }
        }, 300)
      } catch (error) {
        console.warn('Remove notification error:', error)
        // 强制销毁
        try {
          vm.$destroy()
        } catch (destroyError) {
          console.error('Failed to destroy Vue instance:', destroyError)
        }
      }
    }
  }

  return comp
}
